import { connect } from "react-redux";

import { actions as categoriesActions } from "../categories";
import Categories from "./Categories.view";

const mapStateToProps = state => ({
  categoriesCount: state.categoriesCount,
  categoriesError: state.categoriesError,
});

const mapDispatchToProps = dispatch => ({
  lookupCategory: (categoryId, asObj) =>
    dispatch(categoriesActions.lookup(categoryId, asObj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Categories);
